var ShapeBtn = require('./shapeButton');

module.exports = ShapeBtn.extend({
    clickAction: function(e) {
        /*don't allow event to propagate -- now captured in shape view */
        !this.isActive
            ? this.el
                .unmouseover()
                .unmouseout()
            : this.delegateHover();

        this.isActive = !this.isActive;

    }
});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/btn/editDialogToggleButton.js
 ** module id = 228
 ** module chunks = 0
 **/